const getters = {
  tncs: state => state.tnc,
  tnc: state => state.tnc_id,
};

export default getters;
